<template>
  <div style="background-color: #f4fbff; height: 100vh">
    <Header
      :leftArrow="true"
      @leftClick="onClickLeft"
      :rightIcons="false"
    >
    </Header>
    <div class="mypage mypage_sound">
      <div class="wrap mypage_wrap">
        <ul class="mypage_sound-setting">
          <li class="mypage_setting-item" @click="goChooseRing">
            <div class="mypage_link">
              <p class="mypage_menu-name">通話着信音</p>
            </div>
          </li>
          <li class="mypage_setting-item" @click="goChooseMsgRing">
            <div class="mypage_link">
              <p class="mypage_menu-name">メッセージ着信音</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
<!--    <Footer />-->
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import { GetUserDetails } from "@/services/user";
import Footer from "@/components/Footer.vue";
export default {
  data() {
    return {
      userInfo: {},
      ringing_id: "",
      id: null,
    };
  },
  components: {
    Header,Footer
  },
  mounted() {
    this.initUserInfo();
    this.ringing_id = this.$route.query.ringing_id;
    this.id = parseInt(this.$route.query.id);
  },
  methods: {
    initUserInfo() {
      GetUserDetails().then((res) => {
        this.userInfo = res.data.data.detail;
      });
    },
    onClickLeft() {
      history.back();
    },
    goChooseRing() {
      this.$router.push({
        path: "/ringingChoose",
        query: {
          id: this.id,
          ringing_id: this.userInfo.ringing_id,
        },
      });
    },
    goChooseMsgRing() {
      this.$router.push({
        path: "/ringingMsgChoose",
        query: {
          id: this.id,
          ringing_id: this.userInfo.ringing_id_msg,
        },
      });
    },
  },
};
</script>

<style scoped>
   
   
  
</style>
